import type { VFC } from 'react'
import { Link } from '@opallabs/lapidary'
import * as styles from './styles'
import type { LoginLinkProps } from './types'

/**
 * The login link doesn’t make sense for actual user accounts, because the user
 * must already be signed in to see this form. It *is* useful for mass-invite
 * links, though, where people coming to the form are very unlikely to have an
 * existing account.
 */
export const LoginLink: VFC<LoginLinkProps> = ({ theme = 'light', userId }) => {
  if (userId) return null

  return (
    <div css={styles.logIn}>
      Already have an account?&nbsp;
      <Link href="/login" theme={theme}>
        Sign in
      </Link>
      .
    </div>
  )
}
LoginLink.displayName = 'ExAstra: LoginLink ← Form ← AccountCreation'
